<div class="field-container">
  <input class="field-container__input" type="text" [disabled]="progressing" required #searchInput>
  <label class="field-container__label">{{'listing.facets.facet.searchBrand' | translate}}</label>
</div>

